import React from 'react';
import PropTypes from 'prop-types';
import {getI18n} from '../../configurei18n';
import {t} from '@lingui/macro';
import {CaretRightMUI} from '@hig/icons';
import {connect} from 'react-redux';
import './_Breadcrumbs.scss';
import {CONTENT_SUGGESTION, CONTACT_OPTIONS} from '../../app.config';
import {updateShowModal} from '../../actions';

const higsStyles = {
  color: '#3c3c3c',
};

const breadCrumbCaret = () => <CaretRightMUI {...higsStyles} />;

const Breadcrumbs = ({
  goToPrompt,
  showPrompts,
  resetStates,
  seenGuids,
  data,
  componentData,
  componentShowingInUH,
  currentGuid,
  lastComponentShown,
  lastComponentData,
  hideSecondaryNav,
  contactModalityShowing,
  updateShowModal,
}) => {
  const START_GUID = 'start';

  const handleCrumbClick = (event) => {
    event.preventDefault();
    const guid = event.target.getAttribute('data-value');
    if (guid) {
      if (hideSecondaryNav && contactModalityShowing === 'inline_chat') {
        updateShowModal(true, guid);
        return false;
      }

      goToPrompt(guid);
      showPrompts();
      resetStates();
    }
  };

  let breadCrumbs = [];
  const treeObjects = data.prompts;
  breadCrumbs = seenGuids.reduce(
    (crums, guidValue, index) => {
      if (index > 0) {
        crums.push({
          guid: treeObjects[guidValue].guid,
          label: treeObjects[guidValue].label,
          addBackButton: treeObjects[guidValue].addBackButton || ''
        });
      }

      return crums;
    },
    [{guid: START_GUID, label: getI18n()._(t`Home`)}]
  );

  let breadCrumbsMenu = breadCrumbs.map((crumb, index, arr) => {
    // case: prevent Home caret icon for L1 with no children
    const caretFlow = arr.length === 2 && arr[1].addBackButton ? null : breadCrumbCaret();
    let child;

    // case: prevent label for L1 with no children from showing up in crumb
    if ('addBackButton' in crumb && crumb.addBackButton) {
        return <span key={crumb.guid}></span>;
    }

    if (
      Object.keys(componentData).length > 0 ||
      (lastComponentShown === CONTENT_SUGGESTION &&
        componentShowingInUH === CONTACT_OPTIONS)
    ) {
      child = (
        <span
          className="breadcrumb-item"
          data-testid={`breadcrumb-item-${index}`}
          data-value={crumb.guid}
          key={crumb.guid}
        >
          {crumb.label}
          {index < arr.length - 1 && caretFlow}
        </span>
      );
    } else {
      child = (
        <span
          className="breadcrumb-item"
          data-testid={`breadcrumb-item-${index}`}
          data-value={crumb.guid}
          key={crumb.guid}
        >
          {index < arr.length - 1 && crumb.label}
          {index < arr.length - 2 && caretFlow}
        </span>
      );
    }

    return child;
  });

  return (
    <div
      data-testid="breadcrumb_container"
      className="breadcrumb_container"
      onClick={handleCrumbClick}
    >
      {breadCrumbsMenu}
    </div>
  );
};

const noop = () => {};
// Set default props
Breadcrumbs.defaultProps = {
  goToPrompt: noop,
  showPrompts: noop,
  resetStates: noop,
  seenGuids: [],
  data: {},
  componentData: {},
  componentShowingInUH: '',
};

// Set proptype rules
Breadcrumbs.propTypes = {
  goToPrompt: PropTypes.func,
  showPrompts: PropTypes.func,
  resetStates: PropTypes.func,
  seenGuids: PropTypes.array,
  data: PropTypes.object,
  componentData: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    seenGuids: state.workflowPrompts.seenGuids,
    data: state.workflowPrompts.workflowData,
    componentData: state.uiOptions.componentData,
    componentShowingInUH: state.uiOptions.componentShowingInUH,
    currentGuid: state.workflowPrompts.currentGuid,
    lastComponentShown: state.uiOptions.lastComponentShown,
    lastComponentData: state.uiOptions.lastComponentData,
    goToAfterConfirm: state.uiOptions.goToAfterConfirm,
    hideSecondaryNav: state.uiOptions.hideSecondaryNav,
    contactModalityShowing: state.uiOptions.contactModalityShowing,
  };
};

export default connect(mapStateToProps, {
  updateShowModal,
})(Breadcrumbs);
